<div class="aprovacao">
  <button
    class="aprovacao-btn ui-btn ui-btn--secondary d-flex justify-space-evenly align-center"
    (click)="handleOpenModal()"
  >
    Ver contrato completo
  </button>

  <div class="aprovacao-tabs tabs">
    <nav class="tabs-navegacao navegacao d-flex justify-center">
      <ng-container
        *ngFor="let tab of tabs; let i = index"
        class="navegacao-container container d-flex justify-space-evenly"
      >
        <button
          class="container-label d-flex justify-center align-center"
          [ngClass]="{ 'tab-active': currentTab === i + 1 }"
          (click)="changeTab(i)"
        >
          {{ tab.title }}
        </button>
      </ng-container>
    </nav>
  </div>

  <form class="aprovacao-form form d-flex direction-column" [formGroup]="form">
    <h5 class="form-subtitle">Detalhes do contrato</h5>

    <div class="form-inputs d-flex justify-space-between">

      <app-c-input
        class="form-input"
        label="Nº Contrato"
        formControlName="Number"
        placeholder="Informações"
        [readonly]="true"
      >
      </app-c-input>

      <app-c-input
        class="form-input"
        label="Status Contrato"
        formControlName="Status"
        placeholder="Informações"
        [readonly]="true"
      >
      </app-c-input>

      <app-c-input
        class="form-input"
        label="Valor Financiado"
        formControlName="Amount"
        placeholder="Informações"
        inputMask="separator.2"
        [currencyMask]="true"
        [readonly]="true"
      >
      </app-c-input>

      <app-c-input
        class="form-input"
        label="Produto"
        formControlName="Product"
        placeholder="Informações"
        [readonly]="true"
      >
      </app-c-input>

      <app-c-input
        class="form-input"
        label="Tipo de venda"
        formControlName="OperationType"
        placeholder="Informações"
        [readonly]="true"
      >
      </app-c-input>

      <app-c-input
        class="form-input"
        label="Nº Consulta"
        formControlName="QueryNumber"
        placeholder="Informações"
        [readonly]="true"
      >
      </app-c-input>
    </div>
  </form>

  <form class="aprovacao-form form d-flex direction-column" [formGroup]="formGeneric">
    <h5 class="form-subtitle">Detalhes de financiamento</h5>
    <div class="form-inputs d-flex justify-space-between" formGroupName="BatchDetails">
      <app-c-input
        class="form-input"
        label="Status Lote"
        formControlName="BatchStatus"
        placeholder="Informações"
        [readonly]="true"
      >
      </app-c-input>

      <app-c-input
        class="form-input"
        label="Nota Fiscal"
        formControlName="Nfe"
        placeholder="Informações"
        [readonly]="true"
      >
      </app-c-input>

      <app-c-input
        class="form-input"
        label="Valor da Venda (VGV)"
        formControlName="VGC"
        placeholder="Informações"
        [currencyMask]="true"
        [readonly]="true"
      >
      </app-c-input>
    </div>
  </form>

  <div class="aprovacao-footer footer">
    <div class="footer-conteudo conteudo d-flex justify-center align-center">
      <div class="conteudo-botoes botoes d-flex justify-space-between">
        <button class="back" [routerLink]="['/esteira-apuracao']">
          Voltar
        </button>

        <div class="botoes-aprovacao d-flex" *appIsAllowed="['modfin_aprovacao']">
          <button
            class="reprove"
            (click)="approveDisapproveChanges('reject-changes')"
          >
            Reprovar
          </button>
          <button
            class="aprove"
            (click)="approveDisapproveChanges('accept-changes')"
          >
            Aprovar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
